/**
 * @whatItDoes This service manages chat messages on a UZURV reservation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { isNullOrUndefined } from '@uzurv/core';
// eslint-disable-next-line import/order
import { AuthDataService, UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChatMessage } from '../../models';
import { ChatMessageEventService } from './chat-message-event.service';

@Injectable({
  providedIn: 'root'
})
export class ChatMessageService extends UzurvRestService {
  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    private authDataService: AuthDataService,
    domSanitizer: DomSanitizer,
    private chatMessageEventService: ChatMessageEventService
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  sendReadReceipt(chatMessage: ChatMessage): Observable<ChatMessage> {
    if (chatMessage.read) {
      return of(chatMessage);
    }

    return this.patch('chatMessages/' + chatMessage.id, { id: chatMessage.id, read: true }).pipe(
      map(response => {
        const chatMessage = Deserialize(response, ChatMessage);
        this.chatMessageEventService.sendChatMessageReadEvent(chatMessage);
        return chatMessage;
      })
    );
  }

  sortChatMessagesBySentDate(chatMessages: Array<ChatMessage>): Array<ChatMessage> {
    if (isNullOrUndefined(chatMessages)) {
      return [];
    }

    return chatMessages.sort((a, b) => a.createdDate.getTime() - b.createdDate.getTime());
  }

  filterUnreadChatMessagesByPersonId(chatMessages: Array<ChatMessage>, personId: number): Array<ChatMessage> {
    return chatMessages.filter(cm => cm.read === false && cm.recipientPersonId === personId);
  }
}
